import { NumericalColumn, StringColumn } from 'baseui/data-table';
import { APP_LANGUAGE } from 'commons/models/common';

export const COL_NAMES = {
	versionNumber: 'targetVersionCode',
	descriptions: 'descriptions',
	minVersion: 'minVersion',
	maxVersion: 'maxVersion',
	lastUpdatedAt: 'lastUpdatedAt',
	isForceUpdate: 'isForceUpdate',
	updatedBy: 'updatedBy',
	isAvailableOnPlayStore: 'isAvailableOnPlayStore',
	updateOff: 'updateOff',
	deviceType: 'deviceType',
	ludoAppApkUrl: 'ludoAppApkUrl',
	isABTestOn: 'isABTestOn',
	forceBeforeLogin: 'forceBeforeLogin',
	segments: 'segments',
	updateType: 'updateType',
	isSegmentWiseUpdateReq: 'isSegmentWiseUpdateReq'
};

export const columnConfigs = [
	NumericalColumn({
		title: 'Version Number',
		mapDataToValue: (data: any) => data[COL_NAMES.versionNumber]
	}),
	StringColumn({
		title: 'Device Type',
		mapDataToValue: (data: any) => data[COL_NAMES.deviceType]
	}),
	NumericalColumn({
		title: 'Min Version',
		mapDataToValue: (data: any) => data[COL_NAMES.minVersion]
	}),
	NumericalColumn({
		title: 'Max Version',
		mapDataToValue: (data: any) => data[COL_NAMES.maxVersion]
	}),
	StringColumn({
		title: 'Is Force Update',
		mapDataToValue: (data: any) => {
			if (data[COL_NAMES.isSegmentWiseUpdateReq]) {
				return data[COL_NAMES.updateType];
			}
			if (data[COL_NAMES.isForceUpdate]) {
				return 'True';
			}
			return 'False';
		}
	}),
	StringColumn({
		title: 'Ludo App Apk Url',
		mapDataToValue: (data: any) => data[COL_NAMES.ludoAppApkUrl]
	}),
	StringColumn({
		title: 'Segments',
		mapDataToValue: (data: any) => data[COL_NAMES.segments]
	}),
	StringColumn({
		title: 'Description EN',
		mapDataToValue: (data: any) => data[COL_NAMES.descriptions]?.[APP_LANGUAGE.ENGLISH] ?? ''
	}),
	StringColumn({
		title: 'Description HI',
		mapDataToValue: (data: any) => data[COL_NAMES.descriptions]?.[APP_LANGUAGE.HINDI] ?? ''
	})
];
